import { useExtraConfigContext } from '@gov-nx/core/app';
import type { FormDefinition2 } from '@gov-nx/core/service';
import {
	LocalizeNameSpaceTypes,
	useFormBuilder,
	useLocale,
} from '@gov-nx/core/service';
import type { FormCheckboxProps } from '@gov-nx/ui/types';
import { getCheckboxDefinition } from '@gov-nx/utils/common';
import { DATABOX_CONNECT_FORM_ID } from './constants';
import { DataBoxConnectDialogVariant } from './useDataBoxConnectDialog';

interface Data {
	souhlas: boolean;
}

interface Fields {
	souhlas: FormCheckboxProps;
}

interface DataBoxConnectDialogForm {
	form: FormDefinition2<Data, Fields>;
	formId: string;
	isConsentVisible: boolean;
	strings: {
		explanation: string;
	};
}

export const useDataBoxConnectDialogForm = (
	variant: DataBoxConnectDialogVariant
): DataBoxConnectDialogForm => {
	const { t } = useLocale(LocalizeNameSpaceTypes.Form);
	const {
		extraConfig: {
			components: {
				databoxConnectModal: { isConsentCheckboxVisible },
			},
		},
	} = useExtraConfigContext();
	const isConsentVisible =
		variant === DataBoxConnectDialogVariant.Connect && isConsentCheckboxVisible;

	const souhlas = getCheckboxDefinition({
		name: 'souhlas',
		label: t('databox-dialog-form.field.souhlas'),
		oneOf: isConsentVisible
			? {
					value: [true],
					errorMessage: t('databox-dialog-form.validation.souhlas.povinny'),
				}
			: undefined,
	});

	const form = useFormBuilder<Data, Fields>([souhlas]);

	return {
		form,
		formId: DATABOX_CONNECT_FORM_ID,
		isConsentVisible,
		strings: {
			explanation: t('databox-dialog-form.explanation'),
		},
	};
};
